/*
 * File: /src/router/routes/emails.js
 * Created Date: Saturday December 28th 2019
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Saturday, 28th December 2019 3:06:47 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 AdBase, Inc.
 */

const AgentDashboard = () =>
  import(
    /* webpackChunkName: "CallCenter" */ 'src/components/Dashboard/Views/CallCenter/AgentDashboard.vue'
  );

const CallLog = () =>
  import(
    /* webpackChunkName: "CallCenter" */ 'src/components/Dashboard/Views/CallCenter/CallLog.vue'
  );
const CallDashboard = () =>
  import(
    /* webpackChunkName: "CallCenter" */ 'src/components/Dashboard/Views/CallCenter/CallDashboard.vue'
  );
const CallDashboardDetailed = () =>
  import(
    /* webpackChunkName: "CallCenter" */ 'src/components/Dashboard/Views/CallCenter/CallDashboardDetailed.vue'
  );
const Leads = () =>
  import(
    /* webpackChunkName: "CallCenter" */ 'src/components/Dashboard/Views/CallCenter/Leads.vue'
  );
const LeadEdit = () =>
  import(
    /* webpackChunkName: "CallCenter" */ 'src/components/Dashboard/Views/CallCenter/LeadEdit.vue'
  );

export const callCenterRoutes = [
  {
    path: 'call-center/call-dashboard-detailed',
    name: 'Call Dashboard Detailed',
    component: CallDashboardDetailed,
  },
  {
    path: 'call-center/call-dashboard',
    name: 'Call Dashboard',
    component: CallDashboard,
  },
  {
    path: 'call-center/agent-dashboard',
    name: 'Agent Dashboard',
    component: AgentDashboard,
  },
  {
    path: 'call-center/call-log',
    name: 'Call Log',
    component: CallLog,
  },

  {
    path: 'call-center/leads',
    name: 'Leads',
    component: Leads,
    props: route => ({
      followup: route.query.followup === 'true',
      queryAgentIds: route.query.agentId ? Array.isArray(route.query.agentId) ? route.query.agentId.map(a => parseInt(a)) : [parseInt(route.query.agentId)] : undefined,
      queryDateStart: route.query.dateStart,
      queryDateEnd: route.query.dateEnd,
      // Lead status is either a string if one, or an array if more than one.
      // vue-router is supposed to send an array always but it does not
      queryLeadStatus: route.query.leadStatus ? Array.isArray(route.query.leadStatus) ? route.query.leadStatus.map(ls => parseInt(ls)) : [parseInt(route.query.leadStatus)] : undefined,
      queryLeadType: (route.query.leadType != undefined ? Number.parseInt(route.query.leadType) : undefined),
      queryLeadState: route.query.leadState,
      queryLeadCategory: (Number.parseInt(route.query.leadCategory)) || undefined,
      queryTagIds: route.query.tags ? Array.isArray(route.query.tags) ? route.query.tags.map(t => parseInt(t)) : [parseInt(route.query.tags)] : undefined,
    })
  },
  {
    path: 'call-center/leads/:id',
    name: 'Edit Lead',
    component: LeadEdit,
    props: route => ({ leadId: parseInt(route.params.id)}),
  }
];
